import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricMissedImprOtherBing extends MetricBase {
    constructor() {
        super({
            field: "metric_missed_impr_other",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.missedImprOther.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.missedImprOther.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.missedImprOther.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricMissedImprOtherBing;
